import Vue from 'vue'
import Router from 'vue-router'
// 解决安卓路由相关的问题
import '@module/helper/changba-caller'
// 拦截编程式导航，自动添加 curuserid 和 token 参数
import '@module/helper/router-push-replace'
import MainContainer from '../components/MainContainer.vue'
import DetailContainer from '../components/DetailContainer.vue'


Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: MainContainer
  },
  {
    path: '/detail',
    name: 'Detail',
    component: DetailContainer
  }
]

export default new Router({
  mode: 'history',
  base: '/njwap/yunying/sing-together/index/main',
  scrollBehavior() {
  // scrollBehavior(to, from, savePosition) {
    // console.log(to, from, savePosition)
    return { x: 0, y: 0 }
  },
  routes
})

